module.exports = __webpack_public_path__ + "static/media/machine-a.fd988e31.png";